import React from 'react';
import PropTypes from 'prop-types';
import { reduce, get, map, size, filter, includes, has, keyBy } from 'lodash';
import { Form } from 'formik';
import * as Yup from 'yup';
import { Text, If, FlexContainer, AppIcon } from '../../../../../../components/common';
import AuditStatusTable from './variants/AuditStatusTable';
import { Query } from '../../../../../../components/graphql';
import { OrderAuditManagementConsumer } from '../../../../../../components/firebase/OrderAuditManagement';
import AuditHeaderInfo from './AuditHeaderInfo';
import WeightValidationCompact from './variants/WeightValidationCompact'
import { getColumns } from './AuditOrderTable';
import { withFirebase, withReloadable } from '../../../../../../hoc';
import PickingResult from './components/PickingResult';
import { formatRefId } from '../../../../../../utils/misc';
import GET_STOCK_BY_STORE_SKU from '../../../../../../queries/GET_STOCK_BY_STORE_SKU';
const { substituteColumns, parentColumns, compoundColumns } = getColumns();

class AuditOrder extends React.Component {
    state = {
        formValues: {},
        wasSubmitted: {},
        firebase: {},
        pickingResultAllowed: false,
        callAndChatHistoryAllowed: false,
        currentStep: 0,
    };


    _renderItemCacheKey = null;
    _renderItemCache = null;
    _renderItemCacheStockMap = null;

    _getMemoizedRenderTableItem = (data, stockMap) => {
        const cacheKey = data;
        if (
            this._renderItemCacheKey === cacheKey &&
            this._renderItemCacheStockMap === stockMap
        ) {
            return this._renderItemCache;
        }

        this._renderItemCacheKey = cacheKey;
        this._renderItemCacheStockMap = stockMap;
        this._renderItemCache = this._renderTableItem(data, {
            parentColumns: parentColumns,
            subsColumns: substituteColumns,
            compoundColumns: compoundColumns,
            excessColumns: [],
            stockMap
        });

        return this._renderItemCache;
    };

    _renderTableItem = ({ auditInfo, ...ctx }, columns) => (item, index) => {
        const { orderId, orderSelected } = this.props;
        const parentProps = {
            orderId,
            storeId: get(orderSelected, 'idStore', null),
            auditInfo,
            onChangeValue: this.props.onChangeAudits,
            stockMap: get(columns, 'stockMap', {}),
            ...ctx
        };

        const id = String(get(item, 'picking.productId', `item-${index}`));
        const parentCols = get(columns, 'parentColumns', []);
        const subsColumns = get(columns, 'subsColumns', []);
        const containers = [
            { items: parentCols.slice(0, 2), width: '17%', },
            { items: parentCols.slice(2, 5), width: '25%' },
            { items: parentCols.slice(5, 9), width: '33%' },
            { items: parentCols.slice(9, 12), width: '25%' }
        ];
        const subContainers = [
            { items: subsColumns.slice(0, 2), width: '17%', },
            { items: subsColumns.slice(2, 5), width: '25%' },
            { items: subsColumns.slice(5, 9), width: '33%' },
            { items: subsColumns.slice(9, 12), width: '25%' }
        ];
        const compoundCols = get(columns, 'compoundColumns', []);
        const compoundContainers = [
            { items: compoundCols.slice(0, 2), width: '17%', },
            { items: compoundCols.slice(2, 5), width: '25%' },
            { items: compoundCols.slice(5, 9), width: '33%' },
            { items: compoundCols.slice(9, 12), width: '25%' }
        ];
        return (
            <div style={{
                minHeight: '120px',
                width: '100%',
                display: "flex",
                flexDirection: "column",
                marginTop: '8px',
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
                justifyContent:'center',
                alignContent:'center',
                backgroundColor: '#f9f9f9',
            }}>
                <tr
                    key={`item-${id}`}
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'stretch',
                        backgroundColor: '#f9f9f9',

                    }}
                >
                    {containers.map((container, cIndex) => (
                        <td
                            key={`item-${id}-container-${cIndex}`}
                            style={{
                                width: container.width,
                                gap: "4px",
                                justifyContent: 'space-between',
                                alignContent: 'center',
                                verticalAlign: 'middle',
                                borderBottom: '0px'
                            }}
                        >
                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
                                {container.items.map(({ dataIndex, columnStyle, render = () => null }, itemIndex) => (
                                    <div key={`nested-col-${itemIndex}`} style={{ flex: 1, fontSize: '11px', textAlign: 'center', ...columnStyle }}>
                                        {render(item, dataIndex, parentProps)}
                                    </div>
                                ))}
                            </div >
                        </td>
                    ))}
                </tr>
                {item?.picking?.substitution?.length > 0 && (
                    <>
                        <div style={{ height: "30px", justifyContent: 'center', alignContent: 'center', padding: '6px 0px 6px 40px', color: "#99A8B2" }}>
                            <AppIcon name='ic-arrow-substitution' fill="#99A8B2" size='22' />
                        </div>
                        {item?.picking?.substitution?.length > 1 ? (
                            item.picking.substitution.map((subItem, subIndex) => (
                                <tr
                                    key={`item-${id}-compound-${subIndex}`}
                                    style={{
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems:'center',
                                        verticalAlign:'center',
                                        justifyContent: 'space-between',
                                        marginTop: '8px',
                                    }}
                                >
                                    {compoundContainers.map((container, cIndex) => (
                                        <td
                                            key={`item-${id}-compound-${subIndex}-container-${cIndex}`}
                                            style={{
                                                width: container.width,
                                                gap: "4px",
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                borderBottom: '0px',
                                                padding: '3px 0px'
                                            }}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
                                                {container.items.map(({ dataIndex, columnStyle, render = () => null }, itemIndex) => (
                                                    <div key={`nested-compound-col-${itemIndex}`} style={{ flex: 1, fontSize: '11px', textAlign: 'center', ...columnStyle }}>
                                                        {render(subItem, dataIndex, parentProps)}
                                                    </div>
                                                ))}
                                            </div>
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr
                                key={`item-${id}-substitution`}
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems:'center',
                                    justifyContent: 'space-between',
                                    marginTop: '8px',
                                }}
                            >
                                {subContainers.map((container, cIndex) => (
                                    <td
                                        key={`item-${id}-substitution-container-${cIndex}`}
                                        style={{
                                            width: container.width,
                                            gap: "4px",
                                            justifyContent: 'space-between',
                                            alignItems:'center',
                                            borderBottom: '0px'
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
                                            {container.items.map(({ dataIndex, columnStyle, render = () => null }, itemIndex) => (
                                                <div key={`nested-substitution-col-${itemIndex}`} style={{ flex: 1, fontSize: '11px', textAlign: 'center', ...columnStyle }}>
                                                    {render({ ...item.picking.substitution[0], excess: item?.picking?.excess }, dataIndex, parentProps)}
                                                </div>
                                            ))}
                                        </div>
                                    </td>
                                ))}
                            </tr>
                        )}
                    </>
                )}
            </div>
        );
    };

    _renderTableHeader = ({ title, width }, key) => {
        return (
            <th
                className=''
                key={`th-${key}`}
                style={{
                    width: "100%",
                    fontSize: '12px',
                    textAlign: 'center',
                    verticalAlign:'center',
                }}
            >
                {title}
            </th>
        );
    }

    _getHeaderLabels = (columns) => columns.map(({ title, width }) => ({ title, width }))

    _lastFilterInput = null;
    _lastFilterOutput = null;

    _filterItems = (response) => {
        if (response === this._lastFilterInput) {
            return this._lastFilterOutput;
        }

        const { items, auditInfo } = response;
        const invalidItems = map(get(auditInfo, 'results.failed'), ({ productId }) => productId);
        const result = filter(items, (orderItem) => {
            return includes(invalidItems, get(orderItem, 'picking.id')) || includes(['ADDED_BY_CLIENT'], get(orderItem, 'status'));
        });

        this._lastFilterInput = response;
        this._lastFilterOutput = result;
        return result;
    }

    _formGenerateValidationSchema = (fields) => {
        const items = filter(fields, ({ status }) => !includes(['ADDED_BY_CLIENT'], status));
        const _schema = reduce(items, (acc, item) => {
            const productId = get(item, 'picking.productId');
            return Object.assign(acc, {
                [productId]: Yup.object().shape({
                    value: Yup.string().required()
                })
            });
        }, {});
        return Yup.object().shape(_schema);
    }

    componentWillUnmount() {
        if (this._salesChannelUnsub) this._salesChannelUnsub();
        this.props.toggleAudit(false);
    }

    async componentDidMount() {
        await this.props.toggleAudit(true);

        this._salesChannelUnsub = this.props.firebase
            .collection('salesChannel')
            .doc(this.props.orderSelected.salesChannel.id)
            .onSnapshot(doc => {
                this.setState({
                    callAndChatHistoryAllowed: get(doc.data(), 'callAndChatHistory', false),
                    pickingResultAllowed: get(doc.data(), 'pickingResult', false)
                });
            });
    }

    render() {
        const { orderId, data, orderSelected } = this.props;
        const salesChannelId = get(orderSelected, 'salesChannel.id');
        const storeId = get(orderSelected, 'idStore', null);
        const filteredItems = this._filterItems(data);
        const refIds = map(filteredItems, (item) => formatRefId(get(item, 'refId', ''))) || [];
        return (
            <FlexContainer direction='column' flex={1}>
                <If condition={this.state.currentStep === 0} then={(
                    <FlexContainer direction='column' width='100%' display='block' >
                        <AuditHeaderInfo
                            orderId={orderId}
                            dataParent={data}
                            weightValidationCart={<WeightValidationCompact
                                weightError={this.props.weightError}
                                semaphore={this.props.semaphore}
                                callback={() => this.props.setWeightValidation()}
                            />}
                        />
                        <PickingResult
                            pickingResultAllowed={this.state.pickingResultAllowed}
                            orderId={orderId}
                            data={data}
                            salesChannelId={salesChannelId}
                        />

                        <Form>
                            <FlexContainer direction='column' flex={1}>
                                <FlexContainer direction='column' grow={1} mB={100}>
                                    {size(refIds) > 0 && (
                                        <Query
                                            query={GET_STOCK_BY_STORE_SKU}
                                            variables={{ storeId, refIds }}
                                        >
                                            {({ data: stockData }) => {
                                                const stockMap = keyBy(get(stockData, 'getStockByStoreAndSKU.data', []), (item) => formatRefId(get(item, 'matnr', '')));
                                                return (
                                                    <AuditStatusTable
                                                        className='default-table'
                                                        tableProps={{ className: 'order-items-table' }}
                                                        renderItem={this._getMemoizedRenderTableItem(data, stockMap)}
                                                        renderHeader={this._renderTableHeader}
                                                        headers={this._getHeaderLabels(parentColumns)}
                                                        data={filteredItems}
                                                    />
                                                );
                                            }}
                                        </Query>
                                    )}
                                </FlexContainer>
                            </FlexContainer>
                        </Form>
                    </FlexContainer>
                )} />
            </FlexContainer>
        );
    }
}

AuditOrder.propTypes = {
    weightError: PropTypes.bool,
    firstAudit: PropTypes.bool,
    loading: PropTypes.bool,
    data: PropTypes.object,
    orderId: PropTypes.string,
    firebase: PropTypes.object,
    onChangeAudits: PropTypes.func,
    toggleAudit: PropTypes.func,
    orderSelected: PropTypes.object
};

AuditOrder.defaultProps = {
    onChangeAudits: () => { },
    toggleAudit: () => { }
};

export default withReloadable(withFirebase((props) => (
    <OrderAuditManagementConsumer orderId={get(props, 'orderId')}>
        {({ toggleAudit }) => (
            <AuditOrder {...props} toggleAudit={toggleAudit} />
        )}
    </OrderAuditManagementConsumer>
), ['orderId']));
